import { SectionCompletion, SectionInteraction } from '@/app/statistics/section/section-progress';

export interface ObjectCompletionHandlerInterface {
  calculateDefaultInteractions($container: any|null): SectionInteraction[];
  setInteraction(completion: SectionCompletion, interaction: any): SectionCompletion;
}

export const ObjectCompletionHandlerSymbol = Symbol.for('ObjectCompletionHandlerInterface');
